export const NOTIFICATION_SETTING_GROUPS = [
  { id: "campaigns", prefixes: ["campaigns:"] },
  { id: "integrations", prefixes: ["integrations:"] },
] as const;

export type NotificationSettingGroup = (typeof NOTIFICATION_SETTING_GROUPS)[number];
